module.exports = __webpack_public_path__ + "static/media/logo_wnlaw_big.a7f1349b.jpg";